export const PRE_ORDER_EMAIL_TABLE = "preOrderEmails"
export const PRE_ORDER_EMAIL_TABLE_SCHEMA =
  "id, companyId, preOrderId, emailId, syncId, deletedAt"
